export default
[
  { html: '<span class="text-primary">Google Analytics</span>', value: 'ga' },
  { html: '<span class="text-danger">Google tag Manager</span>', value: 'gtm' },
  { html: '<span class="text-info">Facebook Pixel</span>', value: 'fbp' },
]
